import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '../../../../core/i18n';
import { FormErrorSummary } from '../../../../shared/components/form-error-summary/form-error-summary';
import { ValidationMessageService } from '../../services/validation-message.service';

/**
 * Page-level serviceability error summary shown below the global notification banner.
 */
@Component({
  selector: 'app-serviceability-error-banner',
  imports: [FormErrorSummary, TranslatePipe],
  templateUrl: './serviceability-error-banner.html',
  host: { '[style.display]': 'messages().length > 0 ? null : "none"' },
})
export class ServiceabilityErrorBanner {
  private readonly validationMessages = inject(ValidationMessageService);

  protected readonly messages = computed(() => this.validationMessages.serviceabilityErrors());
}
